import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_USER, API_USER_USERNAME } from '@/api/endpoints';
import { USER_QUERY_KEY } from '@/api/queryKeys';
import type { UserInfoResponse } from '@/types/user';
import { unwrapAxiosResponse } from '@/utils/axios';
import { ErrorMessage, logRequestError } from '@/utils/errors';

export const useUpdateUsername = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateUsername, isPending } = useMutation({
    mutationFn: (username: string) =>
      apiClient.post(API_USER_USERNAME, { username }),
    onSuccess: async (_data, username) => {
      queryClient.setQueryData<UserInfoResponse>(USER_QUERY_KEY, (user) =>
        user ? { ...user, username } : user,
      );

      try {
        const freshUser = await apiClient
          .get<UserInfoResponse>(API_USER)
          .then(unwrapAxiosResponse);

        queryClient.setQueryData(USER_QUERY_KEY, freshUser);
      } catch (error) {
        logRequestError(ErrorMessage.ChangeUsername, error);
      }
    },
  });

  return { updateUsername, isPending };
};
